import $fn from "@/utils/fn.ts";
import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 赛事推荐banner列表
interface RecommandBannerJson {
  size: number;
}
export const recommandBanner = (json: RecommandBannerJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.recommandBanner,
    json,
  });
// 专区banner列表
interface AreaBannerJson {
  token: string;
  area_id: number;
}
export const areaBanner = (json: AreaBannerJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.areaBanner,
    json,
  });
// 专区列表
interface AreaListJson {
  token: string;
  size: number;
}
export const areaList = (json: AreaListJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.areaList,
    json,
  });
// 资讯分类列表
interface InfoAssortListJson {
  token: string;
}
export const infoAssortList = (json: InfoAssortListJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.infoAssortList,
    json,
  });
// 资讯分类列表
interface GetInfoJson {
  token: string;
  assort_id?: number;
  page: number;
  size: number;
}
export const getInfo = (json: GetInfoJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.getInfo,
    json,
  });
// 赛事日历接口
interface MatchCalendarJson {
  token: string;
  area_id?: number;
}
export const matchCalendar = (json: MatchCalendarJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.matchCalendar,
    json,
  });
// 赛事日历列表接口
interface MatchCalendarListJson {
  token: string;
  area_id: number;
  start_time: string;
  page: number;
  size: number;
}
export const matchCalendarList = (json: MatchCalendarListJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.matchCalendarList,
    json,
  });
// 专区概述接口
interface MatchAreaSummaryJson {
  token: string;
  area_id: number;
}
export const matchAreaSummary = (json: MatchAreaSummaryJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.matchAreaSummary,
    json,
  });
// 推荐日历赛事接口
interface MatchAreaJson {
  token: string;
}
export const MatchArea = (json: MatchAreaJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.MatchArea,
    json,
  });
// 增加观看次数
interface PlayTimesJson {
  token: string;
  id: string;
  jump_type: number;
}
export const playTimes = (json: PlayTimesJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.playTimes,
    json,
  });
// 赛事资讯
interface MatchInfoJson {
  token: string;
  area_id: number;
  page: number;
  size: number;
}
export const matchInfo = (json: MatchInfoJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.matchInfo,
    json,
  });
// 登录游戏接口
interface MatchAreaGameJson {
  token: string;
  area_id: number;
}
export const matchAreaGame = (json: MatchAreaGameJson): any =>
  http.httpPost({
    url: httpApi.competitionEvent.matchAreaGame,
    json,
  });
// 专区赛事概述标题
interface MatchOutsTitleJson {
  token: string;
  area_id: number;
}
export const matchOutsTitle = (json: MatchOutsTitleJson): any =>
  http.httpPost({
      url: httpApi.competitionEvent.matchOutsTitle,
      json,
  });
// 赛况概述接口
interface MatchOutsJson {
  token: string;
  outs_id: number;
}
export const matchOuts = (json: MatchOutsJson): any =>
  http.httpPost({
      url: httpApi.competitionEvent.matchOuts,
      json,
  });

// 专区背景图
interface MatchAreaBackgroundJson {
  area_id: number;
}
export const matchAreaBackground = (json: MatchAreaBackgroundJson): any =>
  http.httpPost({
      url: httpApi.competitionEvent.matchAreaBackground,
      json,
  });
